import { useQuery } from '@tanstack/react-query';

import { catalogCompanySourceMapApi } from 'api/inventory/catalogCompanySourceMap';

export const COMPANY_SOURCE_OPTIONS_QUERY_KEY = 'catalogCompanySourceOptions';

/**
 * Fetches company source options for catalog company-source mapping UIs.
 *
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true] - Enables the query when true.
 * @returns {import('@tanstack/react-query').UseQueryResult<Array<{text:string,value:number|string}>, Error>}
 */
export const useCompanySourceOptionsQuery = ({ enabled = true } = {}) =>
    useQuery({
        queryKey: [COMPANY_SOURCE_OPTIONS_QUERY_KEY],
        enabled,
        queryFn: async () => {
            const response = await catalogCompanySourceMapApi.getCompanySourceOptions();
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch company sources');
            }
            const companySources = response?.data?.companySources ?? [];
            return companySources.map((item) => ({ text: item.displayName, value: item.id }));
        },
        staleTime: 15 * 60_000,
        gcTime: 30 * 60_000,
    });
